import React, { Component } from "react";
import { Navbar, Modal } from "react-bootstrap";
import "../styles/index.css";
import jwt_decode from "jwt-decode";
import validator from "validator";
import { useEffect, useState } from "react";
//import Table from "../views/FileTable1";
import FileTable from "./FileTable";
//import SIFileTable from './SIFileTable';
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import envConfig from "../config";
import FileAPIData from "./FileAPIData";
import apiService from "../utils/apiService";
import { fetchGuestToken } from "../utils/guestTokenService";

export default class LandingPage extends Component {
  constructor(props) {
    super(props);
    const token = localStorage.getItem("accessToken");
    let beIdArr = [];
    let decoded = {};

    if (token) {
      try {
        decoded = jwt_decode(token) || {};
        console.log("Decoded token:", decoded);
        console.log("extension_beId from token:", decoded.extension_beId);
        if (
          decoded &&
          typeof decoded.extension_beId === "string" &&
          decoded.extension_beId.trim() !== ""
        ) {
          beIdArr = decoded.extension_beId
            .split(",")
            .filter((id) => id.trim() !== "");
          // Call Guest Token API when BEID is present
          fetchGuestToken()
            .then(({ token, fingerprint }) => {
              console.log("Guest token fetched after BEID:");
            })
            .catch((error) => {
              console.error(
                "Failed to initialize guest token for BEID:",
                error
              );
            });
        }
      } catch (e) {
        decoded = {};
      }
    }

    // Initialize state only once with all values
    this.state = {
      selectValue:
        beIdArr.length > 0 ? envConfig.prefix + validator.trim(beIdArr[0]) : "",
      fileDetails: [],
      decoded: decoded,
      beId: beIdArr,
      prefix: envConfig.prefix,
      progress: false,
      open: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.fileSize = this.fileSize.bind(this);
    //const classes=useStyles();
    //toast.configure();
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = (event) => {
    this.setState(
      { selectValue: event.target.value, fileDetails: [], open: true },
      () => {
        this.getListFiles(this.state.selectValue);
      }
    );
  };

  componentDidMount() {
    const { beId = [] } = this.state;
    if (Array.isArray(beId) && beId.length > 0) {
      const value = this.state.prefix + validator.trim(beId[0]);
      this.getListFiles(value);
    }
  }

  // To get the list of files detail from  API
  async getListFiles(input) {
    if (!input) {
      alert("BEID is not present");
      this.setState({ open: false });
      return;
    }
    try {
      // Get authenticated headers using existing guestTokenService
      const headers = await apiService.getAuthHeaders();
      const url = envConfig.getFileListUrl.replace("{BucketName}", input);

      console.log("Making API call:");
      const response = await axios.get(url, { headers });
      this.setState({
        fileDetails: response.data,
        open: false,
      });
    } catch (error) {
      console.error("Error fetching files:", error);

      if (error.response?.status === 401) {
        // This shouldn't happen often due to auto-refresh, but handle edge cases
        alert("Authentication error. Please refresh the page.");
      } else {
        alert("Failed to fetch files. Please check your connection.");
      }

      this.setState({ open: false });
    }
  }

  fileSize() {
    const nf = new Intl.NumberFormat("en-US");
    let totalSize = 0;
    if (this.state.fileDetails.length > 0) {
      for (let i = 0; i < this.state.fileDetails.length; i++) {
        totalSize += Number(this.state.fileDetails[i].Size) || 0;
      }
      totalSize = Number(totalSize).toFixed(6);
    } else {
      totalSize = 0;
    }
    return nf.format(totalSize);
  }

  render() {
    const beId = this.state.beId || [];
    const decoded = this.state.decoded || {};
    const prefix = this.state.prefix || "";
    const fileSize = this.fileSize();

    if (!beId || beId.length === 0) {
      return (
        <div style={{ color: "red", padding: "2em" }}>
          <h3>Data Error</h3>
          <p>
            The required property <code>beId</code> is missing or not mapped to
            your account.
            <br />
            Please contact support or try again later.
          </p>
        </div>
      );
    }

    return (
      <>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.open}
          onClick={this.handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Navbar
          style={{ backgroundColor: "mediumorchid", height: "50px" }}
          variant="dark"
        >
          <h2 className="ms-3">Proprietary Files</h2>
        </Navbar>
        <h6 className="name m-3">Username: {decoded.email}</h6>
        <h6 className="name m-3">
          Total number of files: {this.state.fileDetails.length}{" "}
          &nbsp;&nbsp;&nbsp;&nbsp; Total files size: {fileSize + "  MB"}
        </h6>

        <div
          className="name m-3"
          style={{
            backgroundColor: "white",
            fontSize: "1em",
            fontWeight: "500",
          }}
        >
          <label className="bucketSelect">File Batch: &nbsp;</label>
          {beId && beId.length > 0 ? (
            <select
              className="bucketSelect"
              value={this.state.selectValue}
              onChange={this.handleChange}
            >
              {beId
                .filter((item) => item.trim() !== "")
                .map((item) => (
                  <option key={item}>{prefix + validator.trim(item)}</option>
                ))}
            </select>
          ) : (
            <h6>Bucket name is not mapped to the user</h6>
          )}
          <div className="App">
            {this.state.progress ? <div className="root"> </div> : null}

            <FileAPIData
              bucketName={this.state.selectValue}
              list={this.state.fileDetails}
            />
            {envConfig.appName === "cfsi" ? (
              <div className="dtext">
                <p>
                  Consistent with the requirements of the federal Transparency
                  in Coverage final rule, this machine-readable file is publicly
                  available and accessible free of charge without any condition.
                  This file displays negotiated rates for all covered items and
                  services between Aetna and in-network providers for the plans
                  indicated by <b>Health Insurance Company.</b> Some in-network
                  provider arrangements do not prescribe rates for all covered
                  items and services. In those cases, the provider's
                  reimbursement might be determined in several different ways,
                  but this file would not contain that information.
                </p>
                {/* Rest of the disclaimer text */}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <ToastContainer
          transition={Zoom}
          autoClose={2000}
          draggable={false}
          position={toast.POSITION.TOP_CENTER}
          bodyClassName="toastBody"
        />
      </>
    );
  }
}
